const SimpleImage = (props) => {
  const {
    alt,
    className,
    handleError,
    handleLoad,
    height,
    src,
    width,
    loading,
    ...rest
  } = props
  const dimensionAttributes = {}

  if (typeof height !== "undefined") {
    dimensionAttributes["--height"] = height + "px"
  }

  if (typeof width !== "undefined") {
    dimensionAttributes["--width"] = width + "px"
  }

  // Note: Attributes that are allowed to be overridden must appear before the spread of `rest`.
  return (
    <img
      loading={loading}
      style={dimensionAttributes}
      {...rest}
      alt={alt}
      className={className}
      height={height}
      onError={handleError}
      onLoad={handleLoad}
      src={src}
      width={width}
    />
  )
}

export default SimpleImage
